import React from "react";
import {Row, Col, Form, Input, Select, InputNumber} from 'antd';
import {useSelector, useDispatch} from 'react-redux';
import {  atualizaProduto, getActions } from "../../store/cadastro-produto.reducer";
import { InputNumero } from "../../../../Numeros/input-numero";
import { newProduto } from "../../store/produto.domain";


const TabEstoqueTributario = ({dataTab})=> {


    const {produto:dadosProduto} = useSelector(state => state.produto);
    // const {atualizaProduto} = getActions();
    const dispatch = useDispatch();
    const produto = newProduto(dadosProduto);
   
    const updateUTribHandler = ({target}) => {
        const {value} = target;
        produto.fillUtrib(value);
        dispatch(atualizaProduto(produto.toPlainJson()))
    }

    const updateFatorCorrecaoUTribHandler = ({floatValue}) => {
        produto.fillFatorCorrecaoUnidadeTributaria(floatValue);
        dispatch(atualizaProduto(produto.toPlainJson()))
        
    }

    const updateVUnTribHandler = ({floatValue}) => {
        produto.fillVUnTrib(floatValue);
        dispatch(atualizaProduto(produto.toPlainJson()));
    }
    
    let suffixTransformacao = '';
    if(dadosProduto.uTrib && dadosProduto.uCom !== dadosProduto.uTrib){
        suffixTransformacao = dadosProduto.uTrib;
    }
    return (
        <Row gutter={[16, 16]}>
           
           
            <Col sm={8}>
                <Form.Item label="Unidade Tributária" name="uTrib" onBlur={updateUTribHandler}>
                    <Input data-tab={dataTab} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label={`Para cada ${dadosProduto.uCom} Comercial eu possuo`} name="fatorCorrecaoUnidadeMedidaTrib" >
                    <InputNumero data-tab={dataTab} controls={false} style={{width: "100%"}}  onBlur={updateFatorCorrecaoUTribHandler} addonAfter={suffixTransformacao} />
                </Form.Item>
            </Col>
            <Col sm={8}>
                <Form.Item label="Valor de venda por Unidade Tributaria" name="vUnTrib" >
                    <InputNumero data-tab={dataTab} addonBefore="R$" controls={false} style={{width: "100%"}} onBlur={updateVUnTribHandler} />
                </Form.Item>
            </Col>
           
        </Row>
    );
}

export {TabEstoqueTributario};